import { TuiIdentityMatcher } from '@taiga-ui/cdk';

import { SelectItem } from '../types';

export const selectItemMatcher: TuiIdentityMatcher<SelectItem> = (item1, item2) => item1.id === item2.id;
